import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class EmailSubscriptionMembershipModel extends ModeModelBase {
  override _name = 'emailSubscriptionMembership';
  override idAttribute = 'id';
  override belongsTo = 'reportSubscription';
  override parentIdAttribute = 'id';
  override attributes = [
    { name: 'avatar', default: {} },
    { name: 'email', default: '' },
    { name: 'inWorkspace', default: false },
  ];
}

@Injectable({ providedIn: 'root' })
export class EmailSubscriptionMembershipModelAccessor extends ModelAccessorBase<EmailSubscriptionMembershipModel> {
  override name = 'emailSubscriptionMembership';
  override idAttribute = 'id';
  override parentModel = 'reportSubscription';
  override parentIdAttribute = 'id';
  override createAttributes = ['reportSubscription'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.emailSubscriptionMembership');
  }

  override createModel(resource, opts?) {
    const model = new EmailSubscriptionMembershipModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
